import { useNavigate } from 'react-router-dom';
import {
    useServerSuccessEffect,
    useServerWrite,
} from 'dg-web-shared/lib/hooks/ServerStateHooks.ts';
import {
    ModalVariant,
    OperatorRoutedModal,
} from '../ui/modal/OperatorRoutedModal.tsx';
import { ParkingPortalLayoutWithHeader } from '../mobile/layout/ParkingPortalLayoutWithHeader.tsx';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { ValidationData } from 'dg-web-shared/lib/forms/FormValidationHelpers.tsx';
import { useCloudConnectorRecodeConditions } from './CloudConnectorRecodeQrCodesAdd.tsx';
import { OperatorAsyncLoadedSection } from '../app/components/OperatorAsyncLoadedSection.tsx';
import { LoadingSpinnerPresets } from 'dg-web-shared/common/components/material-ui/PresetLoadingSpinner.tsx';
import { useAutoRecodeOutlet } from './CloudConnectorAutoRecode.tsx';
import {
    AutoRecodeFieldValues,
    CloudConnectorAutoRecodeCreateEditForm,
} from './CloudConnectorAutoRecodeCreateEditForm.tsx';

export function CloudConnectorAutoRecodeCreate() {
    const { refetchAutoRecodesList } = useAutoRecodeOutlet();
    const navigate = useNavigate();
    const [recodeConditionsState] = useCloudConnectorRecodeConditions();

    const [createAutoRecodeState, createAutoRecode] = useServerWrite<
        AutoRecodeFieldValues,
        unknown,
        ValidationData
    >(() => ({
        url: `/ui-api/operator-account/cloud-connector/recode/auto-recode`,
    }));
    useServerSuccessEffect(createAutoRecodeState, () => {
        refetchAutoRecodesList();
        navigate('..');
    });

    return (
        <OperatorRoutedModal
            variant={ModalVariant.TINY}
            backUrl={'..'}
            style={{ maxHeight: undefined }}
            render={() => (
                <ParkingPortalLayoutWithHeader
                    title={
                        <Localized
                            de="Neue Periode"
                            fr="Nouvelle période"
                            it="Nuovo periodo"
                            en="New period"
                        />
                    }
                    backTo={'..'}
                >
                    <OperatorAsyncLoadedSection
                        requestState={recodeConditionsState}
                        pendingLoaderPreset={
                            LoadingSpinnerPresets.FillAllSpaceAndCenter
                        }
                        render={recodeConditionOptions => {
                            return (
                                <CloudConnectorAutoRecodeCreateEditForm
                                    submitState={createAutoRecodeState}
                                    onSubmit={(
                                        formFieldValues: AutoRecodeFieldValues,
                                    ) => {
                                        createAutoRecode({
                                            ...formFieldValues,
                                        });
                                    }}
                                    recodeConditionOptions={
                                        recodeConditionOptions
                                    }
                                    isRecodeAlreadyActive={false}
                                />
                            );
                        }}
                    />
                </ParkingPortalLayoutWithHeader>
            )}
        />
    );
}
